module.exports = __webpack_public_path__ + "static/media/orderDetailsNewNoteIcon.351dfe8f.svg";